export default __webpack_public_path__ + "static/media/Header-Indore.c29e1f19.jpg";